import { useEffect } from 'react';
import { SiderLayout } from '../../../components/layouts/sider';
import Menus from './menu';
import { Routing } from './routing';
import { Route } from 'react-router-dom';
import { Switch } from 'react-router-dom';
import { useLocHref } from '../../../hooks/useLocHref';
import { useMenu } from "../../../hooks/useMenu"
import { useNavs } from '../../../hooks/useNavs';

const TheRouter = () => {
    const routes = Routing.filter(r => (r.level & 131071) > 0);
    return (
        <Switch>
            {
                routes.map((route, idx) => (
                    <Route key={idx} path={route.to} exact={route.isExact !== false} render={props => {
                        return !!route.component && route.component
                    }} />
                ))
            }
            <Route path={'/*'}>
                <div>Page Not Found</div>
            </Route>
        </Switch>
    )
}

export default ({ idx }) => {
    useEffect(() => {
    }, []);
    const key = useLocHref('pjt');
    const { keys, menus } = useMenu(Menus, 131071);
    useNavs(keys, key);
    return (
        <SiderLayout
            menus={menus}
            headerBgColor={"transparent"}
            headerColor={"#141a17"}
        >
            <TheRouter />
        </SiderLayout>
    )
}